import { Modal, Image } from "@mantine/core";
import { CDN_URL } from "../../../constant";

const ImagePopUp = ({ isPanoSpotOpen, setIsPanoSpotOpen, panoSpotDetails }) => {
	return (
		<>
			<Modal
				centered
				size="lg"
				opened={isPanoSpotOpen}
				onClose={() => setIsPanoSpotOpen(false)}
				title={panoSpotDetails.name}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<Image src={CDN_URL + panoSpotDetails.url} fit="cover" />
			</Modal>
		</>
	);
};

export default ImagePopUp;
